import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getProveedoresEntradaMercancia`, method: 'GET', body: null, token: token})
}